<template>
  <div id="addErrorContainer">
    <b-modal
      id="errorModal"
      content-class="menu-bg-blue-transparent-modal"
      title="Add New Error"
      hide-footer
     
      @shown="getPropValues()"
      @hidden="snapshot = null; capturingSnapshot = false"
    >
      <template #modal-header="{ close }">
        <div class="ae-header">
          <span class="ae-header-icon">
            <fa :icon="['fas', 'exclamation-triangle']" />
          </span>
          <div class="ae-header-text">
            <h5 class="ae-title">Add New Error</h5>
            <p class="ae-subtitle">Report a new error on the map</p>
          </div>
          <button type="button" class="ae-close" title="Close" @click="close()">
            <fa :icon="['fas', 'times']" />
          </button>
        </div>
      </template>

      <b-row>
        <b-col class="col-sm-12">
          <div class="ae-info">
            <b-row>
               <b-col>
                <span class="ae-info-item"><span class="ae-info-label">Region</span><span class="ae-info-value">{{ region }}</span></span>
              </b-col>
              <b-col v-if="country">
                <span class="ae-info-item"><span class="ae-info-label">Country</span><span class="ae-info-value">{{ country }}</span></span>
              </b-col>
              <b-col v-if="province">
                <span class="ae-info-item"><span class="ae-info-label">Province</span><span class="ae-info-value">{{ province }}</span></span>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <span class="ae-info-label">Longitude</span>
                <b-form-input v-model="this.errLong" disabled required/>
              </b-col>
              <b-col>
                <span class="ae-info-label">Latitude</span>
                <b-form-input v-model="this.errLat" disabled required/>
              </b-col>
            </b-row>
          </div>
          <b-row class="mt-2">
            <b-col>
              <label> Layer <b class="white-text">*</b></label>
              <b-form-select
                v-model="selectedLayer"
                :options="layerOptions"
                :class="missingFields.layer ? 'red' : ''"
                required
              ></b-form-select>
            </b-col>
            <b-col>
              <label> Dataset <b class="white-text">*</b></label>
              <b-form-select
                v-model="selectedPartNumber"
                :options="modifiedReleases"
                :class="missingFields.dataset ? 'red' : ''"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col id="layerTypeMultiSelect">
              <label> Layer Attribute <b class="white-text">*</b> </label>
              <multiselect
                v-model="selectedLayerType"
                :close-on-select="false"
                :disabled="!layerTypeEnabled"
                :multiple="true"
                :options="layerTypes"
                placeholder=""
              >
                <template slot="selection" slot-scope="{values, isOpen}">
                  <span
                    class="multiselect__single"
                    v-if="values.length && !isOpen"
                  >
                    {{ values.length }} {{ values.length > 1 ? "options" : "option" }} selected
                  </span>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label> Error Type <b class="white-text">*</b></label>
              <b-form-select
                v-model="selectedErrorType"
                :options="errorTypes"
                :class="missingFields.error_type ? 'red' : ''"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <label> Severity <b class="white-text">*</b></label>
              <b-form-select
                v-model="errSeverity"
                :options="severityOptions"
                :class="missingFields.severity ? 'red' : ''"
                required
              ></b-form-select>
            </b-col>
            <b-col>
              <label> Status <b class="white-text">*</b></label>
              <b-form-select
                v-model="errStatus"
                :options="statusOptions"
                :class="missingFields.status ? 'red' : ''"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="6">
              <label> PDT Issue ID </label>
              <b-form-input 
                v-model="issue_id" 
                placeholder="Issue ID"
                style="color: #495057"
                required
              />
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <label> Comments </label>
              <b-form-textarea v-model="errComments" />
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <div>
                <b-button
                  class="ml-2"
                  size="sm"
                  variant="outline-success"
                  :disabled="capturingSnapshot"
                  @click="captureScreenshot()"
                  title="Screen Capture"
                 >
                  <fa v-show="!capturingSnapshot" :icon="['fas','camera']"></fa>
                  <span v-show="capturingSnapshot">Capturing...</span>
                </b-button>
                <b-button
                  v-if="snapshot"
                  class="ml-2"
                  size="sm"
                  variant="outline-danger"
                   title="Remove Screen Capture"
                  @click="snapshot = null"
                >
                  <fa  :icon="['fas','trash']"></fa>
                </b-button>
              </div>
              <div v-if="snapshot" class="mt-2">
                <img
                  :src="snapshot"
                  alt="Error snapshot"
                  style="max-width: 100%; max-height: 150px; border: 1px solid #ccc; border-radius: 4px;"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <button class="drt-submit-btn" @click="submitError()">
                <span>Submit Error</span>
              </button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<style >
.region-label-add {
  position: relative;
  margin-top: -3rem;    
  text-align: right;
  margin-right: 2px;
  margin-bottom: 30px;
}
.yellow {
  color: yellow;
  font-style: italic;
}
.red {
  border: 2px red solid;
  background-color: #FFCCCB; 
}
.white-text {
  color: white;
  font-weight: 900;
}
#errorModal .custom-select {
  min-height: 34px;
  height: 34px;
  padding: 4px 28px 4px 10px;
  font-size: 0.85rem;
}

#errorModal .multiselect--disabled {
  border-radius: 0.25rem !important;
}

#errorModal .multiselect,
#errorModal .multiselect__input,
#errorModal .multiselect__single {
  min-height: 34px !important;
  border-radius: 0.25rem !important;
  color: #495057 !important;
  font-size: 0.85rem !important;
  font-weight: 400 !important;
  font-family: inherit !important;
  text-shadow: none !important;
}

#errorModal .multiselect__placeholder {
  color: #495057 !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
  font-family: inherit !important;
}

#errorModal .multiselect__single {
  color: #495057 !important;
  padding: 0 !important;
}

#errorModal .multiselect__select::before {
  border-color: #495057 transparent transparent !important;
  color: #495057 !important;
}

#errorModal .multiselect__select {
  border-radius: 0.25rem !important;
  height: 32px !important;
}

#errorModal .multiselect__tags {
  min-height: 34px !important;
  border-radius: 0.25rem !important;
  padding: 6px 40px 2px 0.6rem !important;
}

/* padding: 8px 40px 0 8px; */

/* Right-side panel positioning */
#errorModal.modal {
  padding-right: 0 !important;
}
#errorModal .modal-dialog {
  position: fixed;
  right: 2%;
  top: 2%;
  margin: 0;
  height: auto;
  max-height: 96vh;
  width: 600px;
  max-width: 600px;
  transform: none !important;
}
#errorModal .modal-content {
  height: auto;
  max-height: 96vh;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}
#errorModal .modal-body {
  flex: 1;
  overflow-y: auto;
}

.drt-submit-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 8px 0;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 55%, #0f8a3d 100%);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

/* Shine sweep on hover */
.drt-submit-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -80%;
  width: 60%;
  height: 100%;
  background: linear-gradient(105deg, transparent, rgba(255, 255, 255, 0.35), transparent);
  transform: skewX(-18deg);
  transition: left 0.55s ease;
  pointer-events: none;
}
.drt-submit-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
  box-shadow: 0 10px 26px rgba(22, 163, 74, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}
.drt-submit-btn:hover::before {
  left: 130%;
}
.drt-submit-btn:active {
  transform: translateY(1px);
  box-shadow: 0 3px 10px rgba(22, 163, 74, 0.35);
}
.drt-submit-icon {
  font-size: 0.85rem;
  transition: transform 0.2s ease;
}
.drt-submit-btn:hover .drt-submit-icon {
  transform: translateX(3px) rotate(8deg);
}

/* ── Beautified Add Error form ─────────────────────────── */
/* One consistent font across every element in the modal */
#errorModal,
#errorModal * {
  font-family: 'Inter Regular', 'Open Sans', sans-serif !important;
}

#errorModal .modal-content {
  border-radius: 12px !important;
  box-shadow: 0 20px 50px rgba(6, 60, 109, 0.35) !important;
  overflow: hidden;
}
#errorModal .modal-header {
  border-radius: 12px 12px 0 0 !important;
  padding: 0.9rem 1.3rem;
}
#errorModal .modal-body {
  padding: 1rem 1.6rem 1.7rem;
}

/* Roomier vertical rhythm between field rows */
#errorModal .modal-body .row.mt-2 {
  margin-top: 1rem !important;
}
#errorModal .modal-body .row.mt-4 {
  margin-top: 1.75rem !important;
}
#errorModal label,
#errorModal .ae-info-label {
  margin-bottom: 6px;
}

/* Region / country / province emphasis — brand blue instead of yellow */
#errorModal .yellow {
  color: #0a548f;
  font-style: normal;
  font-weight: 700;
}

/* Required-field asterisk — red instead of (invisible) white */
#errorModal .white-text {
  color: #dc3545;
  font-weight: 700;
}

/* Sleek form labels */
#errorModal label {
  display: block;
  font-size: 0.76rem;
  font-weight: 600;
  color: #063c6d;
  margin-bottom: 4px;
}

/* Consistent modern inputs */
#errorModal .form-control,
#errorModal .custom-select,
#errorModal .multiselect__tags {
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  border-radius: 8px !important;
  color: #063c6d;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
#errorModal .form-control:focus,
#errorModal .custom-select:focus {
  border-color: #4a9fe0 !important;
  box-shadow: 0 0 0 3px rgba(74, 159, 224, 0.22) !important;
}
#errorModal input.form-control {
  height: 34px;
  font-size: 0.85rem;
}
#errorModal textarea.form-control {
  min-height: 70px;
  font-size: 0.85rem;
}

/* Custom header */
.ae-header {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.ae-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  font-size: 1rem;
  flex-shrink: 0;
}
.ae-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.01em;
}
.ae-subtitle {
  margin: 0;
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.7);
}
.ae-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-left: auto;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 0.85rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s ease, transform 0.15s ease;
}
.ae-close:hover {
  background: rgba(255, 255, 255, 0.28);
  transform: rotate(90deg);
}

/* Read-only info panel */
#errorModal .ae-info {
  background: linear-gradient(180deg, #f6fafd 0%, #eef4fa 100%);
  border: 1px solid rgba(6, 60, 109, 0.08);
  border-radius: 10px;
  padding: 12px 18px;
  margin-bottom: 1.5rem;
}
.ae-info-item {
  display: flex;
  flex-direction: column;
}
.ae-info-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8ab0cc;
}
.ae-info-value {
  font-size: 0.9rem;
  font-weight: 700;
  color: #063c6d;
}
</style>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
export default {
  name: 'MMP_DRT_AddError',
  components: {
    Multiselect
  },
  props: [
    'customerProjectId',
    'drt_releaseId',
    'errLat',
    'errLayer',
    'errLong',
    'map',
    'releases',
    'selectedDataset',
    'severityOptions',
    'statusOptions',
    'user'
  ],
  data() {
    return {
      province: null,
      country: null,
      errComments: null,
      errSeverity: null,
      errStatus: null,
      feedback: null,
      issue_id: null,
      layerTypeEnabled: false,
      layerOptions: [],
      layerTypes: [],
      modifiedReleases: [],
      errorTypes: [{text: 'Select Error Type', value: null, disabled: true}, 'Missing', 'Incorrect Type', 'Incorrect Placement', 'Duplicate', 'Other'],
      org_name: null,
      projectId: this.customerProjectId ? this.customerProjectId : 0,
      selectedLayer: null,
      selectedLayerType: [],
      selectedErrorType: null,
      selectedPartNumber: null,
      region:this.selectedDataset.extent,
      region_id:this.selectedDataset.extent_id,
      missingFields: {
        layer: false,
        dataset: false,
        layer_type: false,
        error_type: false,
        severity: false,
        status: false
      },
      snapshot: null,
      capturingSnapshot: false
    }
  },
  methods: {
    getLayerOptions(release_id) {
      // REFACTORED to add check for sessionStorage.token (param to api call) -- WEBGIS-2563
      if (sessionStorage.token) {
        axios
        .get(process.env.API_LOCATION + '/api/layer/release', {
          method: 'GET',
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            extent: null,
            release_id: release_id
          }
        })
        .then(response => {
          const content = response.data
          if (content.errors) {
            console.log('release API Call Error: ' + content.errors)
          } else {
            this.layerOptions = [{text: 'Select Layer', value: null, disabled: true}]
            content
              .filter(e => e.visibility != false && !['errors', 'errors_test'].includes(e.layer_name))
              .forEach(link => {
                let linkObj = link.link_object
                // REFACTOR SUGGESTION - what's the point of creating the below object if the only thing being pushed is display_name??
                // SOLUTION: keep for now, might use whole obj later -- WEBGIS-2563
                let objToPush = {
                  name: linkObj.name,
                  zoomControl: linkObj.zoomControl,
                  display_name: linkObj.name.replace(/_/g, ' '),
                  layer_group: linkObj.info.layer_group
                }
                // Push button for DRT layers
                if (objToPush.layer_group.includes('DRT')) {
                  this.layerOptions.push(objToPush.display_name)
                }
              })
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    },
    getLayerTypes(layerName) {
      if (sessionStorage.token) {
        axios
        .get(process.env.API_LOCATION + '/api/layer/getLayerTypes', {
          method: 'GET',
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            layerName: layerName.toLowerCase()
          }
        })
        .then(response => { 
          const content = response.data
          if (content.errors) {
            console.log('layer_types API Call Error: ' + content.errors)
          } else {
            if (content.length && content[0].layer_types) {
              this.layerTypeEnabled = true // Enable only if values
              this.layerTypes = content[0].layer_types
            } else {
              this.layerTypeEnabled = false // Disable if no values
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    },
    getModifiedReleases() {
      let mod = []
      for (let i in this.releases) {
        mod.push({
          text: this.releases[i].part_number,
          value: this.releases[i].part_number
        })
      }
      return mod
    },
    getPropValues() {
      this.modifiedReleases = this.getModifiedReleases()
      this.selectedLayer = null
      this.selectedLayerType = []
      this.selectedErrorType = null
      this.errSeverity = null
      this.errStatus = null
      this.errComments = null
      this.issue_id = null
      this.snapshot = null
      this.capturingSnapshot = false
      this.layerTypeEnabled = false
      this.missingFields = { layer: false, dataset: false, layer_type: false, error_type: false, severity: false, status: false }
      /* Edit - the error type should be selected on Add error page WEBGIS-2703  01/19/2024 */
      //this.selectedLayer = this.errLayer
      this.selectedPartNumber = this.selectedDataset.partNumber
    },
    submitError() {
      let noFieldsLeftNull =        
        this.errLat != null &&
        //this.errLayer != null &&  /* edit - WEBGIS-2703  01/19/2024*/
        this.errLong != null &&
        this.selectedLayer != null &&
        this.selectedPartNumber != null &&
        this.errSeverity != null &&
        this.errStatus != null &&
        !(this.selectedLayerType == null && this.layerTypeEnabled) &&
        this.selectedErrorType != null 

      // Validates that no null values are submitted with the new error.
      if (noFieldsLeftNull) {
        /* Both processed variables are checking to make sure they are
        not null. If they aren't null, they need to have 1 subtracted
        from them because the errors database table is 0-indexed while
        the error_severity and error_status database tables are both
        1-indexed (id columns). If these are null, then just return
        them. */
        // REFACTOR -- WEBGIS-2563
        // refactored: originally checks if errSeverity != null and then runs code. errSeverity is always not null at this point.
        // refactored: originally checks if errStatus != null and then runs code. errStatus is always not null at this point.
        let processedSeverity = parseInt(this.errSeverity) - 1 
        let processedStatus = parseInt(this.errStatus) - 1 

        const selectedSeverityText =
          this.severityOptions.find(option => option.value === this.errSeverity)?.text;

        const selectedStatusText =
          this.statusOptions.find(option => option.value === this.errStatus)?.text;

        let paramsObj = {
          comments: this.errComments,
          created_user: this.user.email,
          dataset: this.selectedPartNumber,
          lat: this.errLat,
          layer_name: this.selectedLayer, //Corrected the model name used to assign value for layer name 
          long: this.errLong,
          severity: processedSeverity,
          status: processedStatus,
          region_id:this.region_id,
          region: this.region,
          layer_type: this.selectedLayerType,
          error_type: this.selectedErrorType,
          issue_id: this.issue_id,
          province: this.province,
          country: this.country,
          selectedSeverityText: selectedSeverityText,
          selectedStatusText: selectedStatusText
        }
        axios
          .get(
            process.env.API_LOCATION + '/api/error/addError/' + this.projectId,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: paramsObj
            }
          )
          .then(response => {
            this.saveSnapshot(response.data.id)
            this.$bvModal.hide('errorModal')
            this.$bvToast.toast('Error added successfully', {
              autoHideDelay: 10000,
              variant: 'success',
              solid: true,
              title: 'Added successfully',
              toaster: 'b-toaster-bottom-center'
            })
            // Refreshes errors layer so error instantly appears.
            this.$emit('refresh', 'errors')
            this.sendNotification(paramsObj);
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        // Else statement figures out which values were null and alerts the user.
        let lastNullValue = ''
        let nullValues = []
        let nullValuesString = 'The '
        let originalNullValuesLength = 0

        // If blocks push null fields to nullValues array
        if (this.errLat == null) {
          nullValues.push('latitude')
        }
        if (this.errLong == null) {
          nullValues.push('longitude')
        }
        if (this.selectedLayer == null) {
          nullValues.push('layer')
          this.missingFields.layer = true;
        }
        if (this.selectedPartNumber == null) {
          nullValues.push('dataset')
          this.missingFields.dataset = true;
        }
        if (this.selectedLayerType == null && this.layerTypeEnabled) {
          nullValues.push('layer attribute')
          this.missingFields.layer_type = true;
        }
        if (this.selectedErrorType == null) {
          nullValues.push('error type')
          this.missingFields.error_type = true;
        }
        if (this.errSeverity == null) {
          nullValues.push('severity')
          this.missingFields.severity = true;
        }
        if (this.errStatus == null) {
          nullValues.push('status')
          this.missingFields.status = true;
        }

        originalNullValuesLength = nullValues.length
        lastNullValue = nullValues.pop()
        nullValuesString += nullValues.join(', ')

        /* If there was more than one null field, use plural grammar in toast.
        If there was only one null field, use singular grammar in toast. */
        if (originalNullValuesLength > 1) {
          nullValuesString +=
            (originalNullValuesLength > 2 ? ', and ' : ' and ') +
            lastNullValue +
            ' fields must be filled out to create an error. Please fill them out and then try again.'
        } else {
          nullValuesString +=
            lastNullValue +
            ' field must be filled out to create an error. Please fill it out and then try again.'
        }

        this.$bvToast.toast(nullValuesString, {
          autoHideDelay: 8000,
          title: 'Error Adding New Error',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center'
        })

        setTimeout(() => {
          this.missingFields = {
            layer: false,
            dataset: false,
            layer_type: false,
            error_type: false,
            severity: false,
            status: false,
            issue_id: false
          }
        }, 8000)
      }
    },
    sendNotification(paramsObj) {
      const d = new Date();

      const timestamp = d.toLocaleDateString(navigator.language, { month:'2-digit', day: '2-digit', year: 'numeric'}) 
                      + ", " + d.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})
      
      let msg = `A new error has been submitted by ${this.user.name}.
                  \nError Details: 
                  **Region: ${paramsObj.region}
                  **Country: ${paramsObj.country ? paramsObj.country : 'N/A'}
                  **Province: ${paramsObj.province ? paramsObj.province : 'N/A'}
                  **Dataset: ${paramsObj.dataset}
                  **Layer: ${paramsObj.layer_name}
                  **Layer Attribute: ${paramsObj.layer_type}
                  **Error Type: ${paramsObj.error_type}
                  **Coordinates (Lat,Long): (${paramsObj.lat},${paramsObj.long})
                  **Severity: ${paramsObj.selectedSeverityText}
                  **Status: ${paramsObj.selectedStatusText}
                  **Created Date: ${timestamp}
                  
                  \n**Comments: ${paramsObj.comments}`

      this.$emit('notification', msg)
    },
    captureScreenshot() {
      this.capturingSnapshot = true
      this.map.once('rendercomplete', () => {
        try {
          const size = this.map.getSize()
          const composite = document.createElement('canvas')
          composite.width = size[0]
          composite.height = size[1]
          const ctx = composite.getContext('2d')

          this.map.getTargetElement()
            .querySelectorAll('.ol-layer canvas, canvas.ol-layer')
            .forEach(c => {
              if (!c.width) return
              const opacity = c.parentNode.style.opacity || c.style.opacity
              ctx.globalAlpha = opacity === '' ? 1 : Number(opacity)
              const t = c.style.transform
              if (t) {
                const m = t.match(/^matrix\(([^)]*)\)$/)
                if (m) ctx.setTransform(...m[1].split(',').map(Number))
              } else {
                ctx.setTransform(
                  parseFloat(c.style.width) / c.width || 1, 0,
                  0, parseFloat(c.style.height) / c.height || 1,
                  0, 0
                )
              }
              try {
                ctx.drawImage(c, 0, 0)
              } catch (taintErr) {
                // skip tainted canvas (e.g. Google Maps basemap, which doesn't support CORS)
              }
            })
          ctx.globalAlpha = 1
          ctx.setTransform(1, 0, 0, 1, 0, 0)
          this.snapshot = composite.toDataURL('image/png')
        } catch (e) {
          this.$bvToast.toast(e.message, {
            title: 'Snapshot failed',
            variant: 'danger',
            autoHideDelay: 6000,
            toaster: 'b-toaster-bottom-center'
          })
        }
        this.capturingSnapshot = false
      })
      this.map.renderSync()
      this.capturingSnapshot = false
    },
    saveSnapshot(errorId) {
      if (!this.snapshot) return
      const arr = this.snapshot.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) u8arr[n] = bstr.charCodeAt(n)
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-')
      const filename = `error_snapshot_${this.errLat}_${this.errLong}_${timestamp}.png`
      const formData = new FormData()
      formData.append('snapshot', new Blob([u8arr], {type: mime}), filename)
      formData.append('lat', this.errLat)
      formData.append('long', this.errLong)
      formData.append('filename', filename)
      formData.append('error_id', errorId)
      formData.append('user', this.user.name)
      axios.post(
        process.env.API_LOCATION + '/api/error/saveErrorSnapshot',
        formData,
        {
          headers: {
            'x-auth-token': sessionStorage.token
          }
        }
      ).catch(err => console.log('Snapshot upload error:', err))
    },
    getProvince() {
      if (sessionStorage.token) {
        axios
        .get(process.env.API_LOCATION + '/api/layer/province', {
          method: 'GET',
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            lat: this.errLat,
            lon: this.errLong
          }
        })
        .then(response => {
          const content = response.data[0]
          if (!content) return
          if (content.errors) {
            console.log('province API Call Error: ' + content.errors)
          } else {
            this.province = content.state_name ?? null
            this.country = content.country ?? null
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    }
  },
  mounted() {
    this.getLayerOptions(this.drt_releaseId)
  },
  watch: {
    selectedLayer: function(newValue) {
      this.layerTypeEnabled = newValue ? true : false
      this.getLayerTypes(newValue)
    },
    errLat: function () {
      this.getProvince()
    }
  }
}
</script>
